import React from "react";
import { FaTrash } from "react-icons/fa";
import "../../assets/css/CartSliderBar.css";
import { useNavigate } from "react-router-dom";
import { useCart } from "../CartContext/CartContextComp";

const CartSlider = ({ onClose }) => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, increaseQuantity, decreaseQuantity } = useCart();

  const totalAmount = cartItems.reduce((total, item) => total + item.price * item.quantity, 0);

  const handleCart = () => {
    navigate("/cart", { state: { cartItems } });
  };

  const handleCheckout = () => {
    navigate("/checkout", { state: { cartItems } });
  };

  return (
    <div className={`cart-slider ${cartItems.length > 0 ? "open" : "closed"}`}>
      <div className="cart-header">
        <h2>Shopping Cart ({cartItems.length})</h2>
        <button className="close-btn" onClick={onClose}>×</button>
      </div>

      <div className="cart-items">
        {cartItems.length > 0 ? (
          cartItems.map((item, index) => (
            <React.Fragment key={index}>
              <div className="cart-item">
                <img src={item.image} alt={item.name} className="cart-img" />
                <div className="cart-info">
                  <p className="cart-product-name">{item.name}</p>
                  <p className="cart-product-details">
                    Size: {item.size} | Rs. {item.price}
                  </p>
                  <div className="quantity-controls">
                    <button onClick={() => decreaseQuantity(item.id, item.size)}>-</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => increaseQuantity(item.id, item.size)}>+</button>
                  </div>
                </div>
                <button className="delete-btn" onClick={() => removeFromCart(item.id, item.size)}>
                  <FaTrash />
                </button>
              </div>
              {index !== cartItems.length - 1 && <hr className="cart-divider" />}
            </React.Fragment>
          ))
        ) : (
          <p className="empty-cart-message">Your cart is empty.</p>
        )}
      </div>

      <div className="cart-footer">
        <p className="cart-total-amount">Total Amount: Rs. {totalAmount}</p>
        <button
          className={`view-cart ${cartItems.length === 0 ? "disabled" : ""}`}
          onClick={handleCart}
          disabled={cartItems.length === 0}
        >
          View Cart
        </button>
        <button
          className={`checkout ${cartItems.length === 0 ? "disabled" : ""}`}
          onClick={handleCheckout}
          disabled={cartItems.length === 0}
        >
          Checkout
        </button>
      </div>
    </div>
  );
};

export default CartSlider;